export default "__VITE_ASSET__WNE7Ma6w__"